import { render, staticRenderFns } from "./PersonalizeScreen.vue?vue&type=template&id=50f97a51&scoped=true"
import script from "./PersonalizeScreen.vue?vue&type=script&lang=js"
export * from "./PersonalizeScreen.vue?vue&type=script&lang=js"
import style0 from "./PersonalizeScreen.vue?vue&type=style&index=0&id=50f97a51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f97a51",
  null
  
)

export default component.exports